module.exports = __webpack_public_path__ + "static/media/cableimg1.31e3001f.png";